import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  media: {
    borderRadius: '20px',
    height:'300px',
    width:'100%',
    [theme.breakpoints.down("xs")]: {
      height:'100px'
  },
  },
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
    width:'100%',
  },
  section1: {
    width:'45%',
    padding: '30px 5px',
    borderRadius: '20px',
    margin: '10px',
    height:'100%'
  },
  section2: {
    display:'flex',
    flexDirection:'column',
    width:'25%',
    padding: '30px 0px',
    borderRadius: '20px',
    margin: '10px',
    textAlign:'left',
  },
  city:{
    paddingTop:'20px',
  },
  category:{
    paddingTop:'20px',
  },
  section3: {
    height:'100px',
    display:'flex',
    flexDirection:'column',
    width:'30%',
    padding: '30px 0px',
    borderRadius: '20px',
    margin: '10px',
    textAlign:'left',
    justifyContent:'space-between'
  },

  description:{
    width:'100%',
    wordWrap:'break-word',
  },
  buttons:{
    marginTop:'auto'
  },
  section4: {
    padding: '30px 15px',
  }
}));